/**
 * Automation Content Review Route
 *
 * This route provides Content Review within the Automation/Agentic context.
 * Platform admins access this via the Automation navigation.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ContentReviewQueue } from "@/components/portal/shared/ContentReviewQueue";

// Define search params for deep linking
type ContentReviewSearch = {
  execution_id?: string;
};

export const Route = createFileRoute("/portal/automation/content-review")({
  component: AutomationContentReview,
  validateSearch: (search: Record<string, unknown>): ContentReviewSearch => {
    return {
      execution_id: search.execution_id as string | undefined,
    };
  },
});

function AutomationContentReview() {
  const navigate = useNavigate();
  const { execution_id: targetExecutionId } = Route.useSearch();

  const handleTargetHandled = () => {
    // Clear the URL param after opening
    navigate({ to: ".", search: {} });
  };

  return (
    <ContentReviewQueue
      targetExecutionId={targetExecutionId}
      onTargetHandled={handleTargetHandled}
    />
  );
}
